import React, { useContext, useState, useEffect, useRef } from 'react'
import ReactPlayer from 'react-player/lazy'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { detectFileType, mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import moment from 'moment'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import {
    validationFunction,
    initialFunction,
    editValue,
} from '@/product/components/species/dynamic/common/FieldFunction'
import './BannerPreview.css'
import { useTranslation } from 'react-i18next'

const TableSettings = (props) => {
    const settingcontext = useContext(SettingContext)
    const variableName = props.variableName
    const arrayValue = props.arrayValue
    const tableHeading = props.tableHeading
    const ignoreField = props.ignoreField
    const { t } = useTranslation()

    const { getGlobalVariable } = useContext(CustomCommonContext)
    const customContext = useContext(CustomCommonContext)

    const [validationArray, setValidationArray] = useState({})
    const [disabled, setDisabled] = useState(false)
    const [valueLoaded, setValueLoaded] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [mapDataValue, setMapDataValue] = useState([])
    const [reload, setReload] = useState(false)
    const [display, setDisplay] = useState([])

    const variableValues = customContext[variableName]
    const tableName = props.tableName
    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: tableName,
            defaultAddition: props?.defaultAddition || false,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                        ? 1
                        : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: global.initialPageLimit ? global.initialPageLimit : 12,
            searchterm: '',
            primaryTable: tableName,
        },
        onSubmit: (values) => {
            let filteredValues = variableValues
            if (props.sortBy) {
                const sortBy = props.sortBy
                filteredValues = filteredValues.sort(
                    (a, b) => a[sortBy] - b[sortBy]
                )
            }
            if (ignoreField && ignoreField.enabled) {
                filteredValues = filteredValues.filter(
                    (filter) => filter[ignoreField.field] !== ignoreField.value
                )
            }
            if (values.searchterm && values.searchterm != '') {
                if (props.search_term_field) {
                    filteredValues = filteredValues.filter(
                        (filter) =>
                            filter[props.search_term_field]
                                ?.toLowerCase()
                                .indexOf(values.searchterm.toLowerCase()) !== -1
                    )
                } else {
                    filteredValues = filteredValues.filter(
                        (filter) =>
                            filter?.description
                                ?.toLowerCase()
                                .indexOf(values.searchterm.toLowerCase()) !== -1
                    )
                }
            }
            setTableBody(filteredValues.length ? filteredValues : [])
            // formikView.values.limit = filteredValues.length
        },
    })

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            table: tableName,
            defaultAddition: props?.defaultAddition || false,
        },
        validateOnBlur: false,
        validationSchema: Yup.object(validationArray),
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log('+++++++++++++', values)
            setDisabled(true)
            if (values.start_time) {
                values.start_time = moment(
                    values.start_time,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
            if (values.end_time) {
                values.end_time = moment(
                    values.end_time,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
            searchTableAction(values)
        },
    })

    const changePagination = () => {
        searchTableFetch(formikView.values, tableName)
    }

    useEffect(() => {
        if (variableValues) {
            let filteredValues = variableValues.length ? variableValues : []
            if (ignoreField && ignoreField.enabled) {
                filteredValues = filteredValues.filter(
                    (filter) => filter[ignoreField.field] !== ignoreField.value
                )
            }
            if (props.sortBy) {
                const sortBy = props.sortBy
                filteredValues = filteredValues.sort(
                    (a, b) => a[sortBy] - b[sortBy]
                )
            }
            setDisplay(filteredValues)
            setDisabled(false)
            setTableBody(filteredValues)
            // formikView.values.limit = variableValues.length
        }
    }, [variableValues])

    useEffect(() => {
        if (search_fetch_data && search_fetch_data.from == tableName) {
            console.log(search_fetch_data.records, 'inside coming or not')
            let filteredValues = search_fetch_data.records.length
                ? search_fetch_data.records
                : []
            if (ignoreField && ignoreField.enabled && filteredValues.length) {
                filteredValues = filteredValues.filter(
                    (filter) => filter[ignoreField.field] !== ignoreField.value
                )
            }
            setTableBody(filteredValues)
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                setTableBody([])
                getGlobalVariable()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const resetForm = () => {
        setInitialValues(initialEmptyValues)
        formik.handleReset()
        setReload(!reload)
    }
    let tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'title',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Title',
        },
        // {
        //     field: 'description',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Description',
        // },
        {
            field: 'active',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
    ]

    if (props.title_reference) {
        tableValues[0] = {
            field: 'title_reference',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Title Reference',
        }
    }
    if (props.show_description) {
        tableValues[1] = {
            field: 'description',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Description',
        }
    }

    if (props?.tableValues) {
        tableValues = [...tableValues, ...props.tableValues]
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickType: 'edit',
        onclick: onClickEdit,
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        tooltipTitle: `Edit ${tableHeading} value`,
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const tableActions = []
    tableActions.push(
        {
            label: 'Move to Active',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Deactive',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        },
        {
            label: 'Delete Permanently',
            icon: <span className="material-icons">cancel</span>,
            onclick: onSelectMultiProducts,
            type: 'delete',
        }
    )

    const searchInfo = [
        {
            label: `${tableHeading} name`,
            placeholder: `Enter ${tableHeading} name`,
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formikView,
        },
    ]

    useEffect(() => {
        setValidationArray({})
        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let handle = validationFunction(
                mapValueArray,
                props.customValidation,
                t
            )
            setValidationArray(handle)
        }
    }, [arrayValue, props.customValidation])

    useEffect(() => {
        setValueLoaded(false)
        setInitialValues({})
        setInitialEmptyValues({})
        setMapDataValue([])

        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let { tempMapData, show } = initialFunction(mapValueArray)

            setInitialValues(show)
            setInitialEmptyValues(show)
            setMapDataValue(tempMapData)

            setTimeout(() => {
                if (tempMapData.length) {
                    setValueLoaded(true)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])

    const handleEdit = (edit_value) => {
        if (edit_value && edit_value.length) {
            let objectPush = editValue(arrayValue, edit_value[0])
            setInitialValues(objectPush)
            setReload(!reload)
        }
    }

    useEffect(() => {
        if (manage.status === 'edit') {
            formik.setFieldValue('id', manage.id)
            const template = variableValues.filter(
                (cat) => cat.id === manage.id
            )
            handleEdit(template)
        } else {
            resetForm()
        }
    }, [manage])
    return (
        <>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="tableSetting_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New{' '}
                        {tableHeading}
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={{
                        records: display,
                        setDisp: `0-${display ? display.length : '0'}`,
                        totalRecords: display ? display.length : 0,
                    }}
                    changeTableFunction={changePagination}
                    hideCompactView={props.hideCompactView}
                    reorder={props.reorder}
                    propertyColumnReOrder={props.propertyColumnReOrder}
                    reorderTable={props.reorderTable}
                    columnStorageVariable={'table_settings_table_manage'}
                    enableTableView={props?.enableTableView || false}
                />
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new'
                        ? `Add ${tableHeading}`
                        : `Edit ${tableHeading}`
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing bannerUpdateCnt mt-4">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {mapData({ formik, data: mapDataValue })}
                            </div>

                            {/* Desktop Banner Preview */}

                            {props?.variableName === 'allHomeBanner' &&
                            formik.values.image?.length ? (
                                <>
                                    <h3 className="bannerPreviewTitle">
                                        Desktop Banner Preview
                                    </h3>

                                    <div className="hero-item">
                                        {/* <img
                                            className="bannerImg"
                                            src={`${global.site_url}/uploads/banner/${formik.values.image}`}
                                            alt="Banner"
                                        /> */}
                                        {detectFileType(
                                            `${global.site_url}/uploads/banner/${formik.values.image}`
                                        ) === 'video' ? (
                                            <ReactPlayer
                                                className="react-player"
                                                width="100%"
                                                height="100%"
                                                url={`${global.site_url}/uploads/banner/${formik.values.image}`}
                                                playing
                                                stopOnUnmount={false}
                                                muted
                                                playsinline
                                                pip
                                                loop={true}
                                            />
                                        ) : (
                                            <img
                                                className="bannerImg"
                                                src={`${global.site_url}/uploads/banner/${formik.values.image}`}
                                                alt="Banner"
                                            />
                                        )}

                                        {/* <div className="container bannerCnt">
                                            <div className="bannerCntInner">
                                                {formik?.values.title ? (
                                                    <h1
                                                        style={{
                                                            color: formik.values
                                                                .color,
                                                        }}
                                                    >
                                                        {formik?.values.title}
                                                    </h1>
                                                ) : null}

                                                {formik?.values.description ? (
                                                    <p
                                                        style={{
                                                            color: formik.values
                                                                .color,
                                                        }}
                                                    >
                                                        {
                                                            formik?.values
                                                                .description
                                                        }
                                                    </p>
                                                ) : null}
                                            </div>

                                            {formik?.values.link ? (
                                                <Button
                                                    className="hero-btn"
                                                    style={{
                                                        border: `1px solid ${formik.values.color}`,
                                                        color: formik.values
                                                            .color,
                                                        backgroundColor:
                                                            formik.values
                                                                .background_color,
                                                    }}
                                                >
                                                    {`${
                                                        formik.values
                                                            ?.button_label
                                                            ? formik.values
                                                                  ?.button_label
                                                            : 'View Details'
                                                    } `}
                                                </Button>
                                            ) : null}
                                        </div> */}
                                    </div>
                                </>
                            ) : null}

                            {/* Mobile Banner Preview */}
                            {props?.variableName === 'allHomeBanner' &&
                            formik.values.image_mobile?.length ? (
                                <>
                                    <h3 className="bannerPreviewTitle">
                                        Mobile Banner Preview
                                    </h3>
                                    <div className="hero-item mobile">
                                        {/* <img
                                            className="bannerImg"
                                            src={`${global.site_url}/uploads/banner/${formik.values.image_mobile}`}
                                            alt="Banner"
                                        /> */}
                                        {detectFileType(
                                            `${
                                                global.site_url
                                            }/uploads/banner/${
                                                formik.values.image_mobile ||
                                                formik.values.image
                                            }`
                                        ) === 'video' ? (
                                            <ReactPlayer
                                                className="react-player"
                                                width="100%"
                                                height="100%"
                                                url={`${
                                                    global.site_url
                                                }/uploads/banner/${
                                                    formik.values
                                                        .image_mobile ||
                                                    formik.values.image
                                                }`}
                                                playing
                                                stopOnUnmount={false}
                                                muted
                                                playsinline
                                                pip
                                                loop={true}
                                            />
                                        ) : (
                                            <img
                                                className="bannerImg"
                                                src={`${
                                                    global.site_url
                                                }/uploads/banner/${
                                                    formik.values
                                                        .image_mobile ||
                                                    formik.values.image
                                                }`}
                                                alt="Banner"
                                            />
                                        )}

                                        {/* <div className="container bannerCnt">
                                            <div className="bannerCntInner">
                                                {formik?.values.title ? (
                                                    <h1
                                                        style={{
                                                            color: formik.values
                                                                .color,
                                                        }}
                                                    >
                                                        {formik?.values.title}
                                                    </h1>
                                                ) : null}

                                                {formik?.values.description ? (
                                                    <p
                                                        style={{
                                                            color: formik.values
                                                                .color,
                                                        }}
                                                    >
                                                        {
                                                            formik?.values
                                                                .description
                                                        }
                                                    </p>
                                                ) : null}
                                            </div>

                                            {formik?.values.link ? (
                                                <Button
                                                    className="hero-btn"
                                                    style={{
                                                        border: `1px solid ${formik.values.color}`,
                                                        color: formik.values
                                                            .color,
                                                        backgroundColor:
                                                            formik.values
                                                                .background_color,
                                                    }}
                                                >
                                                    {`${
                                                        formik.values
                                                            ?.button_label
                                                            ? formik.values
                                                                  ?.button_label
                                                            : 'View Details'
                                                    } `}
                                                </Button>
                                            ) : null}
                                        </div> */}
                                    </div>
                                </>
                            ) : null}

                            {props?.variableName === 'allNotificationBanner' &&
                            formik.values.title?.length ? (
                                <div className="editNotifCnt">
                                    <h3 className="bannerPreviewTitle">
                                        Notification Preview
                                    </h3>

                                    <div className="hero-item">
                                        <div className="container bannerCnt">
                                            <div className="bannerCntInner">
                                                {formik.values?.title ? (
                                                    <p
                                                        className="text-center"
                                                        style={{
                                                            color: formik.values
                                                                .text_color,
                                                            backgroundColor:
                                                                formik.values
                                                                    .background_color,
                                                        }}
                                                    >
                                                        <a
                                                            style={{
                                                                color: formik
                                                                    .values
                                                                    .text_color,
                                                            }}
                                                            className="text-decoration-none"
                                                            href={`${process.env.REACT_APP_DOMAIN}${formik?.values.notification_link}`}
                                                        >
                                                            {
                                                                formik.values
                                                                    ?.title
                                                            }
                                                        </a>
                                                    </p>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            <div className="actionButton d-flex justify-content-center align-items-center">
                                {/* <SecondaryButton
                                    label="Reset"
                                    type="reset"
                                    onClick={() => resetForm()}
                                /> */}
                                <PrimaryButton
                                    id="tableManage_submit"
                                    type="submit"
                                    label="Submit"
                                    disabled={disabled}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to delete ?'
                        : 'Are you sure you want to change the status ?'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="tableSetting_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tableManage_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}
export default TableSettings
